// Phase 3 · Geteilte Effekt-Definitionen für Composer-Vorschau UND Feed-Playback.
// Effekte werden als Metadaten gespeichert und beim Abspielen via CSS/Playback angewandt
// (kein serverseitiges Video-Rendering).

export const FILTER_PRESETS = {
  none: { label: "Original", css: "none" },
  warm: { label: "Warm", css: "saturate(1.25) sepia(0.2) hue-rotate(-10deg)" },
  cool: { label: "Kühl", css: "saturate(1.1) hue-rotate(15deg) brightness(1.05)" },
  vivid: { label: "Lebendig", css: "saturate(1.6) contrast(1.1)" },
  fade: { label: "Verblasst", css: "contrast(0.85) brightness(1.1) saturate(0.8)" },
  vintage: { label: "Vintage", css: "sepia(0.4) contrast(0.9) brightness(1.05) saturate(1.3)" },
  bw: { label: "S/W", css: "grayscale(1) contrast(1.05)" },
  sepia: { label: "Sepia", css: "sepia(0.7)" },
};

export const FILTER_KEYS = Object.keys(FILTER_PRESETS);

export function filterCss(filter) {
  const p = FILTER_PRESETS[filter];
  return p ? p.css : "none";
}

export const SPEED_STEPS = [0.5, 1, 1.5, 2];

// Phase 3 · Sticker-Bibliothek (lizenzfrei · native Emojis, kein SDK/Asset nötig).
// Gruppiert für den Picker; im Bild werden sie als frei platzierbare Overlays gerendert.
export const STICKER_GROUPS = [
  { key: "love", emojis: ["❤️", "💕", "💖", "💗", "💘", "💞", "💓", "😍", "🥰", "😘", "💋", "🌹"] },
  { key: "fun", emojis: ["😂", "🤣", "😎", "🤩", "😜", "🥳", "🤪", "😇", "🙃", "😏", "🤗", "👀"] },
  { key: "sparkle", emojis: ["✨", "⭐", "🌟", "💫", "🔥", "💯", "🎉", "🎊", "🎈", "👑", "🏆", "💎"] },
  { key: "nature", emojis: ["🌈", "☀️", "🌸", "🌺", "🌻", "🦋", "🍀", "🌴", "🌊", "⚡", "❄️", "🌙"] },
  { key: "hands", emojis: ["👍", "🙌", "👏", "🤝", "✌️", "🤙", "🙏", "💪", "👌", "🤟", "👋", "🫶"] },
  { key: "extra", emojis: ["💌", "🎵", "🎶", "📸", "💭", "💥", "🩷", "🖤", "🤍", "💙", "💚", "💛"] },
];

export const ALL_STICKERS = STICKER_GROUPS.flatMap((g) => g.emojis);

export function emptyEffects() {
  return { filter: "none", speed: 1, texts: [], stickers: [] };
}

export function hasEffects(e) {
  if (!e) return false;
  return (e.filter && e.filter !== "none") || (e.speed && e.speed !== 1)
    || (e.texts && e.texts.length > 0) || (e.stickers && e.stickers.length > 0);
}
